<template>
  <section class="hero-section">
    <div class="container">
      <div class="hero-grid">
        <div class="hero-content">
          <div class="hero-badge animate-in">
            <span class="badge-icon"><i class="fas fa-brain"></i></span>
            <span class="badge-text">人工智能技术引领者</span>
            <span class="badge-glow"></span>
          </div>
          <h1 class="hero-title animate-in" data-delay="200">
            弦动魔方<span class="gradient-text">科技</span><br/>
            <span class="title-accent">定制AI解决方案</span>
          </h1>
          <p class="hero-description animate-in" data-delay="400">
            弦动魔方科技有限公司是一家专注于人工智能领域的前沿科技型企业，致力于AI大模型训练、微调定制以及软件应用和硬件应用开发，为客户提供全方位的智能化解决方案。
          </p>
          <div class="hero-actions animate-in" data-delay="600">
            <button class="button is-primary">
              <i class="fas fa-handshake"></i>
              <span>业务合作</span>
              <span class="btn-shine"></span>
            </button>
            <button class="button is-outlined">
              <i class="fas fa-info-circle"></i>
              了解更多
            </button>
          </div>
          <div class="hero-stats animate-in" data-delay="800">
            <div class="stat-item">
              <div class="stat-number">5<span class="stat-plus">+</span></div>
              <div class="stat-label">已有产品数量</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-number">3<span class="stat-plus">+</span></div>
              <div class="stat-label">核心业务领域</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-number">10<span class="stat-plus">+</span></div>
              <div class="stat-label">创新技术专利</div>
            </div>
          </div>
        </div>
        <div class="hero-image-container animate-in" data-delay="200">
          <div class="platform-preview">
            <div class="platform-header">
              <div class="platform-dots">
                <span></span><span></span><span></span>
              </div>
              <div class="platform-title"></div>
            </div>
            <div class="platform-content">
              <div class="ai-visualization">
                <div class="ai-core">AI</div>
                <div class="ai-orbit"></div>
                <div class="ai-orbit orbit-2"></div>
                <div class="ai-orbit orbit-3"></div>
                <div class="ai-particle"></div>
                <div class="ai-particle particle-2"></div>
                <div class="ai-particle particle-3"></div>
              </div>
            </div>
            <div class="platform-features">
              <div class="feature-pill">
                <i class="fas fa-robot"></i>
                <span>AI大模型训练</span>
                <div class="pill-glow"></div>
              </div>
              <div class="feature-pill">
                <i class="fas fa-magic"></i>
                <span>定制化AIGC</span>
                <div class="pill-glow"></div>
              </div>
              <div class="feature-pill">
                <i class="fas fa-tags"></i>
                <span>数据标注</span>
                <div class="pill-glow"></div>
              </div>
              <div class="feature-pill">
                <i class="fas fa-microchip"></i>
                <span>智能硬件</span>
                <div class="pill-glow"></div>
              </div>
            </div>
          </div>
          <div class="image-glow"></div>
        </div>
      </div>
    </div>
    <div class="hero-bg-circle circle-1"></div>
    <div class="hero-bg-circle circle-2"></div>
    <div class="hero-dots"></div>
    <div class="hero-floating-particles">
      <div class="floating-particle p1"></div>
      <div class="floating-particle p2"></div>
      <div class="floating-particle p3"></div>
      <div class="floating-particle p4"></div>
      <div class="floating-particle p5"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  mounted() {
    this.initAnimation();
  },
  methods: {
    initAnimation() {
      const animatedElements = document.querySelectorAll('.animate-in');
      
      animatedElements.forEach(element => {
        const delay = element.getAttribute('data-delay') || 0;
        
        setTimeout(() => {
          element.classList.add('animate');
        }, parseInt(delay));
      });
    }
  }
}
</script>

<style scoped>
.hero-section {
  position: relative;
  padding: 8rem 0 6rem;
  overflow: hidden;
  background-color: var(--bg-dark);
  min-height: 90vh;
  display: flex;
  align-items: center;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  position: relative;
  z-index: 2;
}

.hero-content {
  max-width: 600px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(157, 110, 253, 0.15);
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius-xl);
  margin-bottom: 1.5rem;
  border: 1px solid rgba(157, 110, 253, 0.3);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(157, 110, 253, 0.2);
}

.badge-icon {
  margin-right: 0.5rem;
  color: var(--primary-color);
  text-shadow: 0 0 10px rgba(157, 110, 253, 0.6);
  animation: pulseIcon 2s infinite alternate;
}

.badge-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
}

.badge-glow {
  position: absolute;
  width: 50px;
  height: 100%;
  top: 0;
  left: -100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(157, 110, 253, 0.3),
    transparent
  );
  animation: badgeGlowSweep 3s infinite linear;
}

.hero-title {
  font-size: 3.75rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
  letter-spacing: -0.02em;
  text-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.title-accent {
  color: var(--text-primary);
  position: relative;
  z-index: 1;
}

.title-accent::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0.15em;
  width: 100%;
  height: 0.15em;
  background: var(--primary-color);
  z-index: -1;
  border-radius: 4px;
  animation: expandLine 1.5s ease forwards;
  transform-origin: left;
}

.gradient-text {
  background: linear-gradient(135deg, #9D6EFD 0%, #E879F9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  display: inline-block;
  text-shadow: 0 5px 15px rgba(157, 110, 253, 0.5);
}

.gradient-text::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0.15em;
  width: 100%;
  height: 0.3em;
  background: rgba(157, 110, 253, 0.2);
  z-index: -1;
  border-radius: 4px;
  filter: blur(3px);
}

.hero-description {
  font-size: 1.2rem;
  color: var(--text-secondary);
  margin-bottom: 2.5rem;
  line-height: 1.7;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: relative;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  margin-bottom: 3rem;
}

.button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.75rem;
  border-radius: var(--border-radius-xl);
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  z-index: 1;
  letter-spacing: 0.5px;
}

.button.is-primary {
  background: linear-gradient(135deg, #9D6EFD 0%, #C084FC 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(157, 110, 253, 0.3), 0 8px 30px rgba(157, 110, 253, 0.2);
}

.button.is-primary:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 8px 25px rgba(157, 110, 253, 0.4), 0 15px 35px rgba(157, 110, 253, 0.2);
}

.btn-shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 70%);
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.8s ease;
  z-index: -1;
}

.button.is-primary:hover .btn-shine {
  transform: scale(1);
  opacity: 1;
}

.button.is-outlined {
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--text-primary);
  border: 1px solid rgba(157, 110, 253, 0.3);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.button.is-outlined:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-5px);
  border-color: rgba(157, 110, 253, 0.5);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.hero-stats {
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem;
  background: rgba(42, 35, 68, 0.5);
  border-radius: var(--border-radius-lg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(157, 110, 253, 0.2);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.stat-item {
  text-align: center;
  flex: 1;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.2rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.stat-plus {
  color: var(--primary-color);
  font-size: 1.2rem;
  margin-left: 2px;
  font-weight: 600;
  animation: pulsePlus 2s infinite alternate;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--text-light);
  font-weight: 500;
}

.stat-divider {
  width: 1px;
  height: 30px;
  background: linear-gradient(to bottom, transparent, rgba(157, 110, 253, 0.5), transparent);
}

.hero-image-container {
  position: relative;
  z-index: 2;
}

.platform-preview {
  width: 100%;
  height: 400px;
  background: rgba(42, 35, 68, 0.6);
  border-radius: var(--border-radius-lg);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  overflow: hidden;
  border: 1px solid rgba(157, 110, 253, 0.2);
  display: flex;
  flex-direction: column;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
  transform: perspective(1000px) rotateX(5deg) rotateY(-5deg);
  transform-style: preserve-3d;
  transition: all 0.5s ease;
}

.platform-preview:hover {
  transform: perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(-10px);
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.4);
}

.platform-header {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(157, 110, 253, 0.2);
  background: rgba(33, 27, 54, 0.8);
}

.platform-dots {
  display: flex;
  gap: 6px;
  margin-right: 12px;
}

.platform-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(157, 110, 253, 0.3);
}

.platform-dots span:nth-child(1) {
  background: #ff5f57;
}

.platform-dots span:nth-child(2) {
  background: #ffbd2e;
}

.platform-dots span:nth-child(3) {
  background: #28c940;
}

.platform-title {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 0.9rem;
  flex: 1;
  text-align: center;
  letter-spacing: 0.5px;
}

.platform-content {
  background: linear-gradient(135deg, rgba(27, 22, 50, 0.8) 0%, rgba(42, 35, 80, 0.8) 100%);
  border-radius: 8px;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.3), 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(157, 110, 253, 0.15);
}

.platform-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 30% 30%, rgba(157, 110, 253, 0.1) 0%, transparent 40%),
    radial-gradient(circle at 70% 70%, rgba(232, 121, 249, 0.1) 0%, transparent 40%);
  pointer-events: none;
  opacity: 0.8;
  z-index: 1;
}

.ai-visualization {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.ai-core {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #9D6EFD 0%, #E879F9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: 800;
  box-shadow: 0 0 30px rgba(157, 110, 253, 0.5);
  position: relative;
  animation: pulseCore 2s infinite alternate ease-in-out;
}

@keyframes pulseCore {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 20px rgba(157, 110, 253, 0.4);
  }
  100% {
    transform: scale(1.05);
    box-shadow: 0 0 40px rgba(157, 110, 253, 0.6);
  }
}

.ai-orbit {
  position: absolute;
  border: 1px solid rgba(157, 110, 253, 0.3);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  animation: rotateOrbit 15s infinite linear;
}

.orbit-2 {
  width: 160px;
  height: 160px;
  border-color: rgba(232, 121, 249, 0.25);
  animation-duration: 25s;
  animation-direction: reverse;
}

.orbit-3 {
  width: 200px;
  height: 200px;
  border-color: rgba(157, 110, 253, 0.2);
  animation-duration: 35s;
}

@keyframes rotateOrbit {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.ai-particle {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #9D6EFD;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-left: 60px;
  box-shadow: 0 0 10px rgba(157, 110, 253, 0.8);
  animation: orbitParticle 8s infinite linear;
}

.particle-2 {
  width: 8px;
  height: 8px;
  background: #E879F9;
  margin-left: 80px;
  animation-duration: 12s;
  animation-direction: reverse;
}

.particle-3 {
  width: 6px;
  height: 6px;
  background: #C084FC;
  margin-left: 100px;
  animation-duration: 20s;
}

@keyframes orbitParticle {
  0% {
    transform: rotate(0deg) translateX(60px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(60px) rotate(-360deg);
  }
}

.platform-features {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  padding: 15px;
  background: rgba(27, 22, 50, 0.8);
  border-top: 1px solid rgba(157, 110, 253, 0.15);
}

.feature-pill {
  background: rgba(49, 40, 86, 0.6);
  padding: 8px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(157, 110, 253, 0.2);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  position: relative;
}

.feature-pill i {
  color: var(--primary-color);
  font-size: 14px;
}

.feature-pill span {
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
}

.feature-pill:hover {
  transform: translateY(-5px) scale(1.05);
  background: rgba(59, 48, 103, 0.8);
  border-color: var(--primary-color);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3), 0 0 15px rgba(157, 110, 253, 0.4);
}

.pill-glow {
  position: absolute;
  width: 60px;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(157, 110, 253, 0.2), transparent);
  left: -100%;
  top: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  opacity: 0;
}

.feature-pill:hover .pill-glow {
  opacity: 1;
  animation: sweepGlow 1.5s infinite ease-in-out;
}

@keyframes sweepGlow {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

.image-glow {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-lg);
  background: radial-gradient(circle at 50% 50%, rgba(157, 110, 253, 0.3), transparent 70%);
  filter: blur(30px);
  z-index: -1;
  top: 0;
  left: 0;
  opacity: 0.8;
}

.hero-bg-circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  z-index: 0;
}

.circle-1 {
  width: 500px;
  height: 500px;
  top: -100px;
  right: -100px;
  background: radial-gradient(circle, rgba(157, 110, 253, 0.3) 0%, rgba(21, 17, 43, 0) 70%);
  animation: pulseCircle 8s infinite alternate;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  left: -50px;
  background: radial-gradient(circle, rgba(232, 121, 249, 0.2) 0%, rgba(21, 17, 43, 0) 70%);
  animation: pulseCircle 10s infinite alternate;
  animation-delay: 2s;
}

.hero-floating-particles {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
}

.floating-particle {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(157, 110, 253, 0.8), rgba(157, 110, 253, 0.2));
  filter: blur(3px);
  opacity: 0.4;
  animation: floatParticle 15s infinite ease-in-out;
}

.p1 {
  width: 8px;
  height: 8px;
  top: 15%;
  left: 10%;
  animation-duration: 20s;
}

.p2 {
  width: 12px;
  height: 12px;
  top: 30%;
  right: 15%;
  animation-duration: 25s;
  animation-delay: 2s;
}

.p3 {
  width: 6px;
  height: 6px;
  bottom: 40%;
  left: 20%;
  animation-duration: 18s;
  animation-delay: 5s;
}

.p4 {
  width: 10px;
  height: 10px;
  bottom: 20%;
  right: 30%;
  animation-duration: 22s;
  animation-delay: 3s;
}

.p5 {
  width: 7px;
  height: 7px;
  top: 60%;
  left: 40%;
  animation-duration: 19s;
  animation-delay: 7s;
}

.hero-dots {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: radial-gradient(rgba(157, 110, 253, 0.2) 1px, transparent 1px);
  background-size: 30px 30px;
  opacity: 0.3;
  z-index: 0;
}

.animate-in {
  opacity: 0;
  transform: translateY(30px);
}

.animate-in.animate {
  animation: fadeInUp 0.8s cubic-bezier(0.19, 1, 0.22, 1) forwards;
}

@keyframes pulseIcon {
  0% { 
    opacity: 0.7; 
    transform: scale(1);
  }
  100% { 
    opacity: 1; 
    transform: scale(1.1);
  }
}

@keyframes badgeGlowSweep {
  0% { 
    left: -100%; 
  }
  100% { 
    left: 200%; 
  }
}

@keyframes expandLine {
  0% { 
    transform: scaleX(0); 
  }
  100% { 
    transform: scaleX(1); 
  }
}

@keyframes pulsePlus {
  0% { 
    opacity: 0.5; 
    transform: scale(1);
  }
  100% { 
    opacity: 1; 
    transform: scale(1.2);
  }
}

@keyframes pulseCircle {
  0% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  100% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

@keyframes floatParticle {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(50px, 50px);
  }
  50% {
    transform: translate(100px, 0);
  }
  75% {
    transform: translate(50px, -50px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 992px) {
  .hero-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .hero-content {
    max-width: 100%;
    margin-bottom: 3rem;
  }
  
  .hero-badge {
    margin: 0 auto 1.5rem;
  }
  
  .title-accent::after {
    left: 50%;
    transform: translateX(-50%) scaleX(0);
  }
  
  .animate-in.animate .title-accent::after {
    transform: translateX(-50%) scaleX(1);
  }
  
  .hero-actions {
    justify-content: center;
  }
  
  .hero-stats {
    margin: 0 auto;
  }
  
  .platform-preview {
    max-width: 550px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 768px) {
  .hero-section {
    padding: 7rem 0 5rem;
  }
  
  .hero-title {
    font-size: 2.75rem;
  }
  
  .hero-description {
    font-size: 1.1rem;
  }
  
  .stat-number {
    font-size: 1.4rem;
  }
  
  .platform-preview {
    height: 320px;
  }
  
  .ai-visualization {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 576px) {
  .hero-title {
    font-size: 2.25rem;
  }
  
  .hero-actions {
    flex-direction: column;
  }
  
  .button {
    width: 100%;
  }
  
  .hero-stats {
    padding: 1.25rem;
  }
  
  .stat-number {
    font-size: 1.2rem;
  }
  
  .stat-label {
    font-size: 0.75rem;
  }
  
  .platform-preview {
    height: 200px;
  }
  
  .ai-visualization {
    transform: scale(0.8);
  }
  
  .platform-features {
    gap: 8px;
    padding: 12px;
  }
  
  .feature-pill {
    padding: 6px 10px;
  }
  
  .feature-pill i, 
  .feature-pill span {
    font-size: 12px;
  }
}
</style> 